import React, { useEffect, useMemo } from "react";
import Head from "next/head";

import { useAppSelector } from "hooks/use-app-selector";
import { ProductDetailsType } from "modules/product-details/types";
import modules from "modules";
import { toTitleCase } from "common";

// ===================================================
type Props = { productDetails: ProductDetailsType; productImageLink?: string };
// ===================================================

const ProductSchemaOrgTags: React.FC<Props> = ({
  productDetails,
  productImageLink,
}) => {
  const titleAndDesc = useMemo(() => {
    const { product_name } = productDetails;
    return product_name ? product_name.toUpperCase() : "";
  }, [productDetails]);

  const availability = useMemo(() => {
    if (productDetails?.status?.code === 1) {
      return "InStock";
    }
    return "OutOfStock";
  }, [productDetails?.status?.code]);

  const amount = useMemo(() => {
    let newAmount = productDetails?.retail_price?.toString();

    if (isNaN(parseFloat(newAmount))) {
      // Meaning a not valid amount
      newAmount = "";
    }

    return newAmount;
  }, [productDetails?.retail_price]);

  return (
    <div itemScope itemType="http://schema.org/Product">
      <meta itemProp="name" content={titleAndDesc} />
      <meta itemProp="brand" content={titleAndDesc} />
      <meta itemProp="description" content={titleAndDesc} />
      <meta itemProp="productID" content={productDetails?.product_uuid} />
      <meta itemProp="url" content={window.location.href} />
      <meta itemProp="image" content={productImageLink} />

      {/* <div
          itemProp="value"
          itemScope
          itemType="http://schema.org/PropertyValue"
        >
          <span itemProp="propertyID" data-content="item_group_id" />
          <meta itemProp="value" content="fb_tshirts" />
        </div> */}

      <div itemProp="offers" itemScope itemType="http://schema.org/Offer">
        <link
          itemProp="availability"
          href={`http://schema.org/${availability}`}
        />
        <link itemProp="itemCondition" href="http://schema.org/NewCondition" />
        <meta itemProp="price" content={amount} />
        <meta itemProp="priceCurrency" content="PHP" />
      </div>
    </div>
  );
};

export default ProductSchemaOrgTags;
